export {default as HomeSettingIndex} from './setting/HomeIndex'